import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import router from '../router';

let analyticsTrackingId = 'UA-124339332-4';

if (location.hostname === 'joey.ae.be') {
    analyticsTrackingId = 'UA-124339332-1';
} else if (location.hostname.indexOf('-dev') > -1) {
    analyticsTrackingId = 'UA-124339332-3';
} else if (location.hostname.indexOf('-test') > -1) {
    analyticsTrackingId = 'UA-124339332-2';
}

Vue.use(VueAnalytics, { id: analyticsTrackingId, router, ignoreRoutes: ['barometer'] });
